module.exports = __webpack_public_path__ + "img/sea of tranquility near side.0117bb03.png";